module.exports = "/packs/onbording_01-82bf20f60499ee53ac709fd3d28e43b0.jpg";